module.exports = __webpack_public_path__ + "assets/underscorejs.54053d7e.svg";